import {ICoordinates} from '../utils/location.formatter';

export interface IStationMap {
    center:ICoordinates,
    zoom:number,
    events?:{
      [key:string]:(map:google.maps.Map,
                    eventName:string,
                    ...otherArgs:any[]) => void
    },
    control:any,
    options?:google.maps.MapOptions,
}

export interface IStationMapService {
	getMapOptions(): IStationMap;
	setOverlay(bounds: any, srcImage: string, map: IStationMap): void;
	processMapPolygonPoints(geometry: any, callback: any, thisArg: any, map: any): void;
	loadGeoJson(geojsonUrl: string, mapInstance:IStationMap, googleMaps:any, fillOpacity: number): {getCatchmentBounds(): google.maps.LatLngBounds}
}

export default class StationMapService implements IStationMapService {
	static $inject = ['uiGmapGoogleMapApi', '$timeout'];

	static DEFAULT_CENTER:ICoordinates = {latitude: 42.8746, longitude: 74.5698};
  	static DEFAULT_ZOOM = 10;

  	map:IStationMap;

  	constructor (private uiGmapGoogleMapApi: any, private $timeout: ng.ITimeoutService) {
  		this.map = {
  		  center: StationMapService.DEFAULT_CENTER,
  		  zoom: StationMapService.DEFAULT_ZOOM,
  		  control: {},
	  		  options: {}
	  		};
	  	}

	  	getMapOptions() {
	  		return this.map;
	  	}

	  	loadGeoJson(geojsonUrl: string, mapInstance:IStationMap, googleMaps:any, fillOpacity: number) {
	  		let bounds = new googleMaps.LatLngBounds();

			const map = mapInstance.control.getGMap();
			map.data.addListener('addfeature', (e:any) => {
			  this.processMapPolygonPoints(e.feature.getGeometry(), bounds.extend, bounds, googleMaps);
			  map.fitBounds(bounds);
			});

			map.data.loadGeoJson(geojsonUrl)
			map.data.setStyle({
			  fillColor: '#3f51b5',
			  fillOpacity: fillOpacity,
			  strokeColor: '#283593',
			  strokeWeight: 3
			});
			return {
				getCatchmentBounds: () => {
					return bounds;
				}
			}
	  	}

	  	processMapPolygonPoints(geometry: any, callback: any, thisArg: any, map: any) {
	  	  if (geometry instanceof map.LatLng) {
	  	    callback.call(thisArg, geometry);
	  	  } else if (geometry instanceof map.Data.Point) {
	  	    callback.call(thisArg, geometry.get());
	  	  } else {
	  	    geometry.getArray().forEach((g: any) => {
	  	      this.processMapPolygonPoints(g, callback, thisArg, map);
	  	    });
	  	  }
	  	}


	  	setOverlay(bounds: google.maps.LatLngBounds, srcImage: string, map: IStationMap) {
	  		this.uiGmapGoogleMapApi
	  		  .then((maps: any) => {
		  		// This example creates a custom overlay called USGSOverlay, containing
		  		// a U.S. Geological Survey (USGS) image of the relevant area on the map.

		  		// Set the custom overlay object's prototype to a new instance
		  		// of OverlayView. In effect, this will subclass the overlay class therefore
		  		// it's simpler to load the API synchronously, using
		  		// google.maps.event.addDomListener().
		  		// Note that we set the prototype to an instance, rather than the
		  		// parent class itself, because we do not wish to modify the parent class.

		  		USGSOverlay.prototype = new maps.OverlayView();

		  		/** @constructor */
		  		function USGSOverlay(bounds: google.maps.LatLngBounds, image:string, map: IStationMap) {

		  		  // Initialize all properties.
		  		  this.bounds_ = bounds;
		  		  this.image_ = image;
		  		  this.map_ = map;

		  		  // Define a property to hold the image's div. We'll
		  		  // actually create this div upon receipt of the onAdd()
		  		  // method so we'll leave it null for now.
		  		  this.div_ = null;

		  		  // Explicitly call setMap on this overlay.
		  		  this.setMap(map);
		  		}

		  		/**
		  		 * onAdd is called when the map's panes are ready and the overlay has been
		  		 * added to the map.
		  		 */
		  		USGSOverlay.prototype.onAdd = function() {

		  		  var div = document.createElement('div');
		  		  div.style.borderStyle = 'none';
		  		  div.style.borderWidth = '0px';
		  		  div.style.position = 'absolute';

		  		  // Create the img element and attach it to the div.
		  		  var img = document.createElement('img');
		  		  img.src = this.image_;
		  		  img.style.width = '100%';
		  		  img.style.height = '100%';
		  		  img.style.position = 'absolute';
		  		  div.appendChild(img);

		  		  this.div_ = div;

		  		  // Add the element to the "overlayLayer" pane.
		  		  var panes = this.getPanes();
		  		  panes.overlayLayer.appendChild(div);
		  		};

		  		USGSOverlay.prototype.draw = function() {

		  		  // We use the south-west and north-east
		  		  // coordinates of the overlay to peg it to the correct position and size.
		  		  // To do this, we need to retrieve the projection from the overlay.
		  		  var overlayProjection = this.getProjection();

		  		  // Retrieve the south-west and north-east coordinates of this overlay
		  		  // in LatLngs and convert them to pixel coordinates.
		  		  // We'll use these coordinates to resize the div.
		  		  var sw = overlayProjection.fromLatLngToDivPixel(this.bounds_.getSouthWest());
		  		  var ne = overlayProjection.fromLatLngToDivPixel(this.bounds_.getNorthEast());

		  		  // Resize the image's div to fit the indicated dimensions.
		  		  var div = this.div_;
		  		  div.style.left = sw.x + 'px';
		  		  div.style.top = ne.y + 'px';
		  		  div.style.width = (ne.x - sw.x) + 'px';
		  		  div.style.height = (sw.y - ne.y) + 'px';
		  		};

		  		// The onRemove() method will be called automatically from the API if
		  		// we ever set the overlay's map property to 'null'.
		  		USGSOverlay.prototype.onRemove = function() {
		  		  this.div_.parentNode.removeChild(this.div_);
		  		  this.div_ = null;
		  		};

		  		new (<any>USGSOverlay)(bounds, srcImage, map.control.getGMap());
	  		});
  	}
}


/** WEBPACK FOOTER **
 ** ./app/station/station-map.service.ts
 **/